export const listeDossiersPath = '';
export const detailDossierPath = ':idDossier';
export const dossierValidationPath = ':idDossier/validation';
export const addFormalityPath = ':idDossier/ajouter-une-formalite';
